import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { RunStatus } from '../runs/run-status.enum';
import { OptimisationStatus } from '../shared/enums/optimisation-status.enum';
import { STATUS } from './status.pipe';

@Component({
  selector: 'status-badge',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './status-badge.component.html',
  styleUrls: ['./status-badge.component.css']
})
export class StatusBadgeComponent {
  @Input({ required: true }) status: RunStatus | OptimisationStatus | undefined;

  get look() { return this.status ? STATUS[this.status] : undefined; }
}
